import { createListenerMiddleware } from '@reduxjs/toolkit';
import { addMiddleware } from 'redux-dynamic-middlewares';
import { mapStateActions } from 'features/searchResultsMap';
import matchesMobileUserAgent from 'modules/deviceCapabilities';

const isMobileDevice = matchesMobileUserAgent();
const searchBarContainer = isMobileDevice
  ? document.querySelector('[data-search-bar-container-mobile]')
  : document.querySelector('[data-search-bar-container-desktop]');
const typeaheadInput = searchBarContainer.querySelector('[data-search-input]');
const listenerMiddleware = createListenerMiddleware();

/**
 * Using the listener middleware to listen to the enableSearchWithinMap action.
 * This listener is in charge of cleaning the typeahead field when the enableSearchWithinMap action is dispatched.
 */
listenerMiddleware.startListening({
  type: mapStateActions.enableSearchWithinMap.type,
  effect: () => {
    typeaheadInput.value = '';
  },
});

addMiddleware(listenerMiddleware.middleware);
